<template>
  <div class="col-12 fadein-details">
    <confirm v-if="!busy && !survey" :text="confirmationText" @confirmation="handleConfirmation" />
    <reject-survey v-if="survey && !busy" :lead="lead" @close="$emit('close')" />
    <spinner v-if="busy" />
  </div>
</template>

<script>
import RejectSurvey from "@/components/pane/RejectSurvey";
import Confirm from "@/components/pane/Confirm";
import Spinner from "@/components/animation/Spinner";
import gaEvent from "@/imports/mixins/gaEvent";
export default {
  name: "Reject",
  components: {Spinner, Confirm, RejectSurvey},
  mixins: [gaEvent],
  props: ['lead'],
  data: function() {
    return {
      busy: false,
      survey: false,
      confirmationText: "Are you sure you would like to decline this lead?",
    }
  },
  computed: {
    isOffered: function() {
      if (this.lead.offered !== undefined) {
        return this.lead.offered === 1;
      }
      return (this.lead.availability_guarantee_until !== undefined);
    }
  },
  methods: {
    handleConfirmation(confirmed) {
      if(confirmed) {
        this.rejectLead()
      } else {
        this.$emit('cancel');
      }
    },
    rejectLead: function() {
      this.error = false;
      this.busy = true;
      this.$api.leads
        .reject((this.lead[0] !== undefined) ? this.lead[0].id : this.lead.enquiry.id)
        .then(() => {
          this.survey = this.isOffered;
          this.busy = false;
          this.fireEvent(this.lead, "rejected");
          this.$emit('rejected');
          if (!this.isOffered) {
            this.$emit('close')
          }
        })
        .catch((error) => {
          if(error.response.data.errors) {
            this.error = error.response.data.errors[0];
          } else {
            this.error = "There was an error while processing your request";
          }
          this.busy = false;
        });
    },
  }
}
</script>

<style scoped>

</style>
